import AbsComponent from "../../components/AbsComponent";
import Checkbox from '../components/Checkbox';
import SideCategory from './SideCategory';

export default class SideMain extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);

        new Checkbox(
            'SideClass', this.store, this.actions, this.router, 
            '.gameinfo-filter__list .class article', 'class', '/game/character-classes'
        );
        new Checkbox(
            'SideGrade', this.store, this.actions, this.router, 
            '.gameinfo-filter__list .grade article', 'grades', '/game/grades'
        );
        new SideCategory(
            'SideCategory', this.store, this.actions, this.router, 
            '.gameinfo-filter__list .category article'
        );

        $('.gameinfo-filter__title .btn-refresh').on('click', e =>{
            this.router.goMultiParam({
                class: '',
                grades: '',
                category1: '',
                category2: '',
                page: 1
            });
        });

        $('.gameinfo-filter-wrapper .btn-close').on('click', e =>{
            $('.gameinfo-filter-wrapper').removeClass('is-active');
        });
    }

} // end of class